/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { createContext, useState } from "react"
import { useTranslation } from "react-i18next"

export const LanguageContext = createContext()

const LanguageProvider = ({ children }) => {
    const { i18n } = useTranslation()
    const [selectedLang, setSelectedLang] = useState("id")

    const changeSelectedLang = (value) => {
        setSelectedLang(value)
        i18n.changeLanguage(value)
    }

    return (
        <>
            <LanguageContext.Provider value={{ selectedLang, changeSelectedLang }}>
                {children}
            </LanguageContext.Provider>
        </>
    )
}

export default LanguageProvider
